import Cookies from 'js-cookie';
import {getCrossSubdomainCookieDomain} from '../helpers/cookieHelpers';

const GOOGLE_CLICK_ID = 'gclid',
      FBCLID = 'fbclid',
      FBCLID_TIMESTAMP = 'fbclid_timestamp',
      // Landing click ids the server falls back on (migrationContextService);
      // the 90-day expiry is its click bound, the fbclid pair carries its time.
      // Written whatever the consent decision: click ids are not personal data
      // and always go to the ad platforms (CT-798). They stay classified as
      // Marketing in Cookiebot (fbclid, fbclid_timestamp, gbraid, wbraid, msclkid).
      LANDING_CLICK_IDS = [FBCLID, 'gbraid', 'wbraid', 'msclkid'],
      LANDING_CLICK_ID_PATTERN = /^[\w-]{1,512}$/u,
      LANDING_CLICK_COOKIE_OPTIONS = {'expires': 90};

/**
 * Service for handling Google Click ID tracking for conversion attribution : SCP-3112
 */
class GoogleClickTrackingService {
	init() {
		// Pages that turn tracking off (the payment page, CT-376) store no click ids.
		if (window.globalParams?.trackingAllowed === false) {
			return;
		}

		this.#initGoogleClickTracking();
		this.#storeLandingClickIds();
	}

	/**
	 * @private
	 */
	#initGoogleClickTracking() {
		const currentGoogleClickId = this.#extractGoogleClickIdFromUrl();

		if (currentGoogleClickId) {
			this.#storeGoogleClickId(currentGoogleClickId);
		}
	}

	/**
	 * @private
	 */
	#storeLandingClickIds() {
		const urlParams = new URLSearchParams(window.location.search);

		LANDING_CLICK_IDS.forEach((name) => {
			const id      = urlParams.get(name),
			      isKnown = Cookies.get(name) === id &&
				      (name !== FBCLID || Cookies.get(FBCLID_TIMESTAMP) !== undefined);

			// A reload of the landing URL keeps the first-seen click time and expiry.
			if (!LANDING_CLICK_ID_PATTERN.test(id ?? '') || isKnown) {
				return;
			}

			this.#setCookie(name, id, LANDING_CLICK_COOKIE_OPTIONS);

			if (name === FBCLID) {
				this.#setCookie(FBCLID_TIMESTAMP, String(Date.now()), LANDING_CLICK_COOKIE_OPTIONS);
			}
		});
	}

	/**
	 * @returns {string|null}
	 * @private
	 */
	#extractGoogleClickIdFromUrl() {
		const urlParams = new URLSearchParams(window.location.search);

		return urlParams.get(GOOGLE_CLICK_ID);
	}

	/**
	 * @param {string} googleClickId
	 * @private
	 */
	#storeGoogleClickId(googleClickId) {
		this.#setCookie(GOOGLE_CLICK_ID, googleClickId);
	}

	/**
	 * @param {string} name
	 * @param {string} value
	 * @param {!Object} [extraOptions]
	 * @private
	 */
	#setCookie(name, value, extraOptions = {}) {
		Cookies.set(
			name,
			value,
			{
				'path'    : '/',
				'sameSite': 'Lax',
				'domain'  : getCrossSubdomainCookieDomain(),
				...extraOptions
			}
		);
	}
}

export default new GoogleClickTrackingService();